const ms_Translations = {
	mainMenu: {
		hello: 'Hi (ms)',
	},
	main: {
		labels: {
			learnMore: 'Learn More',
			buyNow: 'Buy Now',
			get3dps: 'Get my 3D Printing Solution',
			whereToBuy: 'Where To Buy',
			checkout: 'Checkout',
			checkoutCartNote: 'Taxes, shipping and discounts calculated at checkout',
			shippingCartNote:
				'Please note that current shipping times may extend up to 4 weeks due to increased demand.',
			total: 'Total',
			apply: 'Apply',
			emptyCart: 'Empty cart',
			enterDiscountCode: 'Enter discount code or gift card',
			ctaGoShopResins: 'Get my 3D Printing Resins',
			ctaGoShopFlowResins: 'Get my FLOW 3D Printing Resins',
			add3dpsToCart: 'Add my 3DPS to Cart',
			yourBundle: 'Your Bundle',
			soldOut: 'Sold Out',
			seeCart: 'See Cart',
			addToCart: 'Add to Cart',
			unselectAll: 'Unselect all',
			selectAll: 'Select All',
			selectAllInPage: 'Select all in this Page',
			clearAllFilters: 'Clear All',
			checkAllFilters: 'Check All',
			categories: 'Categories',
			continents: {
				asia: 'Asia',
				africa: 'Africa',
				europe: 'Europe',
				oceania: 'Oceania',
				southAmerica: 'South America',
				centralAmerica: 'Central America',
				northAmerica: 'North America',
				others: 'Others',
			},
		},
	},
};
